import styled from 'styled-components';

export const StyledMapContainer = styled.div`
    width: 100%;
    height: 100%;

    & :focus {
        outline: 0;
    }
`;

export const StyledMapProgress = styled.div`
    position: absolute;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: rgb(176, 57, 57);
    background: #fff;
    opacity: 0.8;
`;
